import List from "./List";

declare interface INavigableNode<T> {
    T: T;
    hasNext: boolean;
    hasPrev: boolean;
    readonly next: T;
    readonly prev: T;
}

export function navigableNode<T>(_node_: T, array: List<T> | T[]): INavigableNode<T> {
    const nodeIndex = array.findIndex(element => element === _node_);
    const node = typeof _node_ === "object" ? _node_ : { value: _node_ } as T;

    return Object.create(node as Object, {
        hasNext: {
            value: Boolean(array[nodeIndex + 1])
        },
        hasPrev: {
            value: Boolean(array[nodeIndex - 1])
        },
        next: {
            get() {
                return array[nodeIndex + 1]
            }
        },
        prev: {
            get() {
                return array[nodeIndex - 1]
            }
        }
    });
}
